module.exports = __webpack_public_path__ + "static/media/course.cf5ae3cc.svg";